const pushToDataLayer = (data) => {
  if (!!window?.top?.dataLayer?.push) {
    return window.top.dataLayer.push(data)
  }

  return false
}

export const flushGA4 = function (key) {
  pushToDataLayer({[key]: null})
}

export const pushGA4 = function (data, flushKey) {
  if (!flushKey) {
    console.warn('GA4 required to flush data before pushing. Please check you pushGA4 function.', data);
    return;
  }

  flushGA4(flushKey);
  pushToDataLayer(data);
}

export default pushToDataLayer
